module.exports = __webpack_public_path__ + "img/ico_select_player2.bf3cac46.png";